import { render } from "./Offers.vue?vue&type=template&id=4a219ba8&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"

import "./Offers.vue?vue&type=style&index=0&id=4a219ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a219ba8"]])

export default __exports__